import React, { Fragment, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import withTranslations from '../../../utils/HighOrderComponent.js';
import FormWrapper from '../../Reusable/FormWrapper/FormWrapper.js';
import LoadingIndicator from '../../Reusable/LoadingIndicator.js';
import CustomModal from '../../Reusable/Modal/CustomModal.js';

const HistoryLoginModal = (props) => {
  const { t, show, onSubmitHandler, hideModal, closeButton } = props;

  const { historyLoginList, loading } = useSelector(
    (state) => state.userReducer
  );

  const successfullyLogin = historyLoginList?.find((login) => login.successful);
  const submitRef = useRef();
  const unsuccessfullyLoginList = historyLoginList
    ?.filter((login) => !login.successful)
    ?.map((login, index) => {
      return (
        <Row key={++index}>
          <Col className="flex-center-center history-login-case-date">
            {login.loginTime}
          </Col>
        </Row>
      );
    });

  const userLabel = successfullyLogin
    ? successfullyLogin?.firstName + ' ' + successfullyLogin?.lastName
    : '';
  const dateOfUserMail = successfullyLogin
    ? '(' + successfullyLogin?.email + ')'
    : '';

  return (
    <Fragment>
      <CustomModal
        show={show}
        title={t.title}
        hideModal={hideModal}
        closeButton={closeButton}
        onFooterButtonClick={() => submitRef.current.click()}
        footerButtonLabel={t.buttonLabel}
      >
        <LoadingIndicator
          loading={loading}
          showOnComponentLevel
          spinnerSize={110}
        />
        <FormWrapper submitRef={submitRef} onSubmit={onSubmitHandler}>
          <Row>
            <Col md={6} className="m-auto">
              <Row>
                <Col className="flex-center-center history-login-user">
                  {userLabel}
                </Col>
              </Row>
              <Row>
                <Col className="flex-center-center history-login-email">
                  {dateOfUserMail}
                </Col>
              </Row>
              <Row>
                <Col className="flex-center-center history-login-case-title">
                  {t.successfullyTittle}
                </Col>
              </Row>
              <Row>
                <Col className="flex-center-center history-login-case-label">
                  {t.successfullyLabel}
                </Col>
              </Row>
              <Row>
                <Col className="flex-center-center history-login-case-date">
                  {successfullyLogin?.loginTime}
                </Col>
              </Row>
              <Row>
                <Col className="flex-center-center history-login-case-title">
                  {t.unsuccessfullyTittle}
                </Col>
              </Row>
              {unsuccessfullyLoginList?.length > 0 ? (
                unsuccessfullyLoginList
              ) : (
                <Row>
                  <Col className="flex-center-center history-login-case-label">
                    {t.unsuccessfullyLabel}
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </FormWrapper>
      </CustomModal>
    </Fragment>
  );
};

export default withTranslations(HistoryLoginModal, 'HistoryLoginModal');
